<script setup lang="ts">
import { computed } from 'vue';
import type { JustifyContent } from './types';

const props = withDefaults(
  defineProps<{
    justifyContent?: JustifyContent | null;
    form?: boolean;
  }>(),
  {
    justifyContent: null,
    form: false,
  },
);

const className = computed(() => {
  let r = props.form ? 'row g-3' : 'row';

  if (props.justifyContent) {
    return `${r} justify-content-${props.justifyContent}`;
  }

  return r;
});
</script>

<template>
  <div :class="className">
    <slot />
  </div>
</template>
